module.exports = __webpack_public_path__ + "img/Bouclier05.906d6da4.png";